import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';

const MultipleRemoveMerchants = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'added.merchants.multi.remove',
        text: 'Do you want to remove selected merchants?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple remove merchants">
      <FontAwesomeIcon
        color={'red'}
        size={'lg'}
        icon={solid('xmark')}/>
    </button>
  );
};

export default MultipleRemoveMerchants;
